/* eslint-disable no-restricted-syntax */

// https://easings.net/

/* eslint-disable @typescript-eslint/no-magic-numbers, custom/require-jsdoc-except, custom/max-top-level-functions-per-file, @stylistic/js/no-mixed-operators */
import type { TEasings } from './definitions'

const linear     = (t: number): number => t
const inQuad     = (t: number): number => t * t
const outQuad    = (t: number): number => t * (2 - t)
const inOutQuad  = (t: number): number => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t)
const inCubic    = (t: number): number => t * t * t
const outCubic   = (t: number): number => --t * t * t + 1 // eslint-disable-line no-param-reassign
const inOutCubic = (t: number): number => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1)
// const outElastic = (t: number): number => t === 0 ? 0 : (t === 1 ? 1 : Math.pow(2, -10 * t) * Math.sin((t * 10 - 0.75) * (2 * Math.PI) / 3) + 1)

const easings: TEasings = {
  linear,
  inQuad,
  outQuad,
  inOutQuad,
  inCubic,
  outCubic,
  inOutCubic
}

export default easings
